var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 10C23 8.89543 22.1046 8 21 8H19.9381C19.446 4.05369 16.0796 1 12 1C7.92038 1 4.55399 4.05369 4.06189 8H3C1.89543 8 1 8.89543 1 10V14C1 15.1046 1.89543 16 3 16H6V9C6 5.68629 8.68629 3 12 3C15.3137 3 18 5.68629 18 9V15C18 18.0712 15.6924 19.7445 12.7165 19.9729C12.367 19.3901 11.7291 19 11 19C9.89543 19 9 19.8954 9 21C9 22.1046 9.89543 23 11 23C11.7499 23 12.4034 22.5873 12.7457 21.9766C16.4837 21.7396 19.4763 19.7031 19.9381 16H21C22.1046 16 23 15.1046 23 14V10ZM8.81958 13.5887L7.75944 15.2849C8.98882 16.0549 10.4424 16.5 12 16.5C13.5576 16.5 15.0112 16.0549 16.2406 15.2849L15.1804 13.5887C14.2584 14.1662 13.1682 14.5 12 14.5C10.8318 14.5 9.74161 14.1662 8.81958 13.5887Z",
    fill: "#16191E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChat);
export default __webpack_public_path__ + "static/media/icon-chat.4a35be05f3f4619610acad04e434b9d6.svg";
export { ForwardRef as ReactComponent };